import { styled } from "sharedUI/styles";

export const OrgsSidebarStyle = styled.div`
    display: flex;
    flex-direction: column;
    width: 300px;
    overflow-y: auto;
    background-color: ${p => p.theme.bgFront};
    padding: 16px;
    color: ${p => p.theme.fgColorDarkest};
    font-size: 14px;
    box-shadow: 1px 0px 0px rgba(49, 49, 57, 0.05);
    z-index: 1;

    .logo-small {
        margin: 4px 0 8px 4px;

        .bg {
            color: ${p => p.theme.fgColorDark};
        }

        .fg {
            color: ${p => p.theme.fgColorAccent};
        }
    }

    & svg {
        color: ${p => p.theme.fgColorLight};
        flex-shrink: 0;
    }

    & .osb-user-photo {
        width: 32px;
        height: 32px;
        object-fit: cover;
        border-radius: 16px;
        background-color: ${p => p.theme.bgColorMedium};
    }

    & .osb-user-header {
        display: flex;
        align-items: center;

        span {
            margin-left: 10px;
            flex-grow: 1;
        }
    }

    & li {
        list-style-type: none;
        cursor: pointer;
    }

    & ul li ul li {
        margin: 16px 0 16px 35px;
        color: ${p => p.theme.fgColorDark};
        font-size: 13px;
    }

    & .osb-header {
        display: flex;
        justify-content: start;
        align-items: center;
        height: 36px;
        border-radius: 9px;
        padding: 6px 8px;
        margin-top: 8px;
        color: ${p => p.theme.textXpale};
        font-size: 13px;
        font-weight: 400;
        transition: all ${p => p.theme.transitionBase};
        cursor: pointer;

        > :first-child {
            margin-right: 10px;
        }

        &:hover {
            background-color: ${p => p.theme.n100A};
            color: ${p => p.theme.textPale};

            .osb-btn-icon {
                box-shadow: ${p => p.theme.shadow2};
            }
        }
    }

    .osb-btn-icon {
        display: inline-flex;
        padding: 4px;
        border-radius: 6px;
        background-color: ${p => p.theme.buttonOutline.bgColor};
        box-shadow: ${p => p.theme.shadowDark1};
        transition: all ${p => p.theme.transitionBase};

        svg {
            color: ${p => p.theme.iconBase};
        }
    }

    & button.osb-header {
        margin-top: 24px;
        cursor: pointer;
    }

    & .osb-header-title {
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
    }

    & .osb-selected {
        font-weight: 600;
        color: ${p => p.theme.acceptColor};
        background-color: ${p => p.theme.acceptColor + "1e"};
    }

    & .osb-selected svg {
        color: ${p => p.theme.acceptColor};
    }

    & > ul {
        margin-top: 8px;
        flex-grow: 1;
    }

    & .osb-hack path:last-child {
        color: #00d563;
    }

    & .osb-selected-section {
        position: relative;
        font-weight: 600;
        color: ${p => p.theme.acceptColor};

        ::before {
            content: "";
            background-color: ${p => p.theme.acceptColor};
            position: absolute;
            left: -25px;
            top: calc(50% - 4px);
            width: 8px;
            height: 8px;
            border-radius: 100px;
        }
    }
`;
